// Top-of-app banner die zichtbaar is zolang er nog GEEN compleet TOC-pad
// bestaat (doelgroep → activiteit → effect). Alleen relevant voor orgs die
// het impactMeten-module actief hebben — orgs met alleen housevisits/personas
// hebben geen TOC nodig en zien de banner dus niet.
//
// Gebruikers die geen volledige TOC nodig hebben kunnen hem permanent
// wegklikken via "Negeren" — slaat `TOCBannerDismissed: true` op
// CompagnyMeta zodat de keuze tenant-breed persisteert.
//
// PERF: outer-component checkt `subscription.modules.impactMeten` voordat de
// inner-component (die `useTOCProgress` aanroept) mount. Zo abonneren we
// alleen op de 3 TOC-collecties wanneer dat ook écht relevant is.
//
// Klik op de knop navigeert naar de TOC-overzichtpagina (Impactstrategie-
// submenu, eerste pagina) zodat de gebruiker manueel verder kan invullen.
//
// Spec: docs/features/onboarding-flow.md sectie "TOC nudge".

import { useHistory } from 'react-router-dom'
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'

import { client } from '../../hooks/Client'
import { db } from '../../firebase/config'
import useSettings from '../../hooks/Settings'
import useTOCProgress from '../../hooks/useTOCProgress'

const TOCProgressBannerInner = ({ docid }) => {

    const history = useHistory()
    const { hasCompleteChain, loading } = useTOCProgress()

    if (loading || hasCompleteChain) return null

    const continueTOC = () => {
        history.push(`/${client}/impactstrategy`)
    }

    const dismiss = async () => {
        if (!docid) return
        try {
            await db.collection('CompagnyMeta').doc(docid).update({
                TOCBannerDismissed: true,
            })
        } catch (err) {
            console.error('TOCProgressBanner dismiss error', err)
        }
    }

    return (
        <div className="toc-progress-banner" role="status">
            <AutoAwesomeOutlinedIcon className="toc-progress-banner-icon" />
            <span className="toc-progress-banner-text">
                Je TOC is nog niet af.
            </span>
            <button
                type="button"
                className="toc-progress-banner-button"
                onClick={continueTOC}
            >
                Klik hier om door te gaan
            </button>
            <button
                type="button"
                className="toc-progress-banner-dismiss"
                onClick={dismiss}
            >
                Negeren
            </button>
        </div>
    )

}

const TOCProgressBanner = () => {

    const { subscription, tocBannerDismissed, docid } = useSettings()

    // Banner alleen voor orgs met impactMeten — leest uit Subscriptions-doc
    // (nieuwe shape) of legacy `ImpactFunctionality` via mapLegacyToSubscription.
    const hasImpactMeten = !!subscription?.modules?.impactMeten
    if (!hasImpactMeten) return null

    // Gebruiker heeft de banner eerder weggeklikt — tenant-breed dismissed.
    if (tocBannerDismissed) return null

    return <TOCProgressBannerInner docid={docid} />

}

export default TOCProgressBanner
